import { createSelector } from 'reselect';
import { collapseHighlightsSectionPdpSelector } from 'selectors/testTarget/offers/collapseHighlightsSectionPdp/collapseHighlightsSectionPdpSelector';

const showSelector = createSelector(collapseHighlightsSectionPdpSelector, collapseHighlightsSectionPdp => !!collapseHighlightsSectionPdp.show);

export { showSelector };
